// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6755 ? "premiumcarousel.637162dd" : chunkId) + "--" + {"3332":"01a1393","3543":"bd2eed3","5273":"8b63973","6755":"8c92923"}[chunkId] + ".css";
};